<div class="mat-bg-surface flex flex--column">
  <mat-toolbar>
    <h1>
      Products
      @if (clientCode()) {
        (<strong>{{ clientName() }}</strong
        >)
      }
    </h1>

    <span class="spacer"></span>
    <div class="cell-actions">
      @if (authService.isAdminOrEditor()) {
        <button matMiniFab matTooltip="Add Product" (click)="edit()">
          <mat-icon>add</mat-icon>
        </button>
      }
      <button matIconButton (click)="reload()">
        <mat-icon [class.rotating]="pending()">refresh</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <div class="grid">
    <div class="c-12">
      <div class="cell-actions">
        <mat-form-field>
          <mat-label>Search</mat-label>
          <input matInput [(ngModel)]="filter" />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Status</mat-label>
          <mat-select multiple [(ngModel)]="filterStatus">
            @for (item of statusOptions(); track item) {
              <mat-option [value]="item">{{ item }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <lcm-po-select (poSelected)="filterPo.set($event)"></lcm-po-select>
      </div>

      <table
        mat-table
        matSort
        [dataSource]="source()"
        [trackBy]="trackBy"
        matSortActive="JobNumber"
        matSortDirection="desc"
      >
        <ng-container matColumnDef="ClientCode">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Code</th>
          <td mat-cell *matCellDef="let item">{{ item.ClientCode }}</td>
        </ng-container>

        <ng-container matColumnDef="_ClientName">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Client</th>
          <td mat-cell *matCellDef="let item">{{ item._ClientName }}</td>
        </ng-container>

        <ng-container matColumnDef="JobNumber">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let item">{{ item.JobNumber }}</td>
        </ng-container>

        <ng-container matColumnDef="Title">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let item">{{ item.Title }}</td>
        </ng-container>

        <ng-container matColumnDef="Status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let item">{{ item.Status }}</td>
        </ng-container>

        <ng-container matColumnDef="JiraTitle">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Jira</th>
          <td mat-cell *matCellDef="let item">
            <a href="{{ jira.link(item.JiraTitle) }}" target="_blank"> {{ item.JiraTitle }} </a>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let item">
            <div class="cell-actions">
              <button
                matIconButton
                matTooltip="Agreements"
                [routerLink]="['/app/agreements', item.ClientCode, item.JobNumber]"
              >
                <mat-icon>assignment</mat-icon>
              </button>
              @if (authService.isAdmin()) {
                <button matMiniFab (click)="edit(item)" [disabled]="pending()">
                  <mat-icon>edit</mat-icon>
                </button>
              }
              <a matMiniFab [routerLink]="['/app/products/view', item.JobNumber]">
                <mat-icon>remove_red_eye</mat-icon>
              </a>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToShow()"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToShow()"></tr>
      </table>

      <mat-paginator [pageSize]="10" [showFirstLastButtons]="true" />
    </div>
  </div>
</div>
